import React, { useEffect, useState } from "react";
import ProzoDataGrid from "../../../common/ProzoDataGrid";
import { Box, Button, Typography } from "@mui/material";
import { apiConstants, postGeneric } from "../../../common/constants";
import { parseDateAndTime } from "../../../helpers/UtilityHelper";
import MUIModal from "../../../common/MUIModal";
import ApproveRequest from "./Action";
import AwbLinkCell from "../../../common/AwbLinkCell";
import Loader from "../../../common/Loader"
import { getMerchant } from "../../../helpers/ReduxHelpers";
import { primaryTextSx, secondaryTextSx, cellStackSx, awbTextSx } from '../list2/cellStyles';
import { FONT, SIZE } from '../../../styles/foundation/typography';


const PendingOrders = () => {
    const [page, setPage] = useState(0);
    const [sizePerPage, setSizePerPage] = useState(10);
    const [data, setData] = useState([])
    const [dataCount, setCount] = useState(0)
    const [itemModalData, setItemModalData] = useState();
    const [approveModalData, setApproveModalData] = useState();
    const [approveModaOpen, setApproveModalOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [reload, setReload] = useState(0);
    const merchant = getMerchant();
    const merchantId = merchant.id ? merchant.id : ''

    useEffect(() => {
        setIsLoading(true)
        const payload = {
            "andfilter": [
                {
                    "field": "itemData.isRequestPlaced",
                    "operator": "eq",
                    "value": true
                },
                {
                    "field": "merchantOid",
                    "operator": "eq",
                    "value": merchantId
                },
                {
                    "field": "isAutoApprovalOrder",
                    "operator": "eq",
                    "value": false
                },
            ],
            "orfilter": [
                {
                    "field": "itemData.remainingActionableItems",
                    "operator": "gt",
                    "value": 0
                }
            ],
            "offset": page * sizePerPage,
            "limit": sizePerPage,
            "skipCount": true,
            "controllerFilter": true,
            "excludes": "otp"
        }
        postGeneric(`${apiConstants.RETURN_EXCHANGE_ORDER_LIST}?conditionFlag=Pending&offset=${page * sizePerPage}&limit=${sizePerPage}`, payload).then((res) => {
            setCount(res.data?.resultData?.count)
            setData(res.data?.resultData?.data)
            setIsLoading(false)
        }).catch((err) => {
            console.log(err);
            setIsLoading(false)
        })
    }, [page, sizePerPage, reload, merchantId])

    const columns = [
        {
            field: "awbNumber",
            headerAlign: "left",
            hideSortIcons: true,
            headerName: "Forward AWB Number",
            flex: 1,
            minWidth: 180,
            renderCell: (params) => {
                const { row } = params;
                return (
                    <Box sx={cellStackSx}>
                        <AwbLinkCell awb={row?.awbNumber} sx={awbTextSx} />
                    </Box>
                )
            },
        },
        {
            field: "shippingLabelId",
            headerAlign: "left",
            hideSortIcons: true,
            headerName: "Shipping Label ID",
            flex: 0.7,
            minWidth: 140,
        },
        {
            field: "dates",
            headerAlign: "left",
            hideSortIcons: true,
            headerName: "Dates",
            flex: 1.5,
            minWidth: 260,
            renderCell: (params) => {
                const { row } = params;
                return (
                    <Box sx={cellStackSx}>
                        <Typography sx={secondaryTextSx}><span style={{ fontWeight: 600 }}>Created:</span> {parseDateAndTime(row.createdDate)}</Typography>
                        <Typography sx={secondaryTextSx}><span style={{ fontWeight: 600 }}>Delivered:</span> {parseDateAndTime(row.deliveryDate)}</Typography>
                        <Typography sx={secondaryTextSx}><span style={{ fontWeight: 600 }}>Return Request Received:</span> {parseDateAndTime(row.orderRequestedDate)}</Typography>
                    </Box>
                );
            },
        },
        {
            field: "isAllOrderReturn",
            headerAlign: "left",
            hideSortIcons: true,
            headerName: "Return Type",
            flex: 1,
            minWidth: 180,
            renderCell: (params) => {
                const { row } = params;
                return row.isAllOrderReturn ? (
                    <Box sx={cellStackSx}>
                        <Typography sx={primaryTextSx}>
                            Order wise return
                        </Typography>
                        <Typography sx={secondaryTextSx}>
                            Reason : {row?.rvpReason}
                        </Typography>
                    </Box>
                ) : (
                    <Box sx={cellStackSx}>
                        <Typography sx={secondaryTextSx}>
                            SKU wise return
                        </Typography>
                    </Box>
                );
            },
        },
        {
            field: "action",
            headerAlign: "left",
            hideSortIcons: true,
            headerName: "Action",
            flex: 0.5,
            minWidth: 100,
            renderCell: (params) => {
                const { row } = params;
                return (
                    <Button
                        onClick={() => {
                            setApproveModalData(row.itemData);
                            setItemModalData(row);
                            setApproveModalOpen(true);
                        }}
                        sx={{
                            fontFamily: FONT,
                            fontSize: SIZE['2xs'],
                            textTransform: 'none',
                            p: 0,
                            minWidth: 0,
                        }}
                    >
                        View Items
                    </Button>
                )
            },
        },
    ]
    return (
        <>
            {isLoading && <Loader />}
            <ProzoDataGrid
                columns={columns}
                autoHeight={true}
                rows={data?.length > 0 ? data?.map((val, index) => ({ ...val, id: index })) : []}
                sizePerPage={sizePerPage}
                setSizePerPage={setSizePerPage}
                setPage={setPage}
                page={page}
                pagination={true}
                hideFooterPagination={false}
                // rowCount={Number.MAX_VALUE}
                rowCount={dataCount ? dataCount : Number.MAX_VALUE}
                getRowId={(row) => row.id}
            />
            <MUIModal title='Manage Return Request' open={approveModaOpen} handleClose={() => setApproveModalOpen(false)} children={<ApproveRequest approveModalData={approveModalData} itemModalData={itemModalData} setApproveModalOpen={setApproveModalOpen} setReload={setReload} />} />
        </>
    );
};

export default PendingOrders
